import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/spent-estimate-list';
import AggregateSpentEstimate from "../../aggregate/special/aggregate-spent-estimate";
import AggregateSpentEstimateComponent from "./components/aggregate-spent-estimate";

export default class SpentEstimateField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.SPENT_ESTIMATE;
        this.valueType = gd.const.fields.valueType.FLOAT;
    }

    static getValue(item) {
        let res;

        if (!item.estimate) res = null;
        else if (!item.reportedTime) res = 0;
        else res = Math.floor(100 * item.reportedTime/item.estimate);

        return res;
    }

    get sortHintMessage() {
        return 'Sort by spent / estimate';
    }

    getAggregateValue(item) {
        return {
            reportedTime:   item.reportedTime,
            estimate:       item.estimate
        };
    }

    getCsvValue(item) {
        return SpentEstimateField.getValue(item);
    }

    getValue(item) {return SpentEstimateField.getValue(item)}

    getAggregateClass() {return AggregateSpentEstimate}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.AVERAGE,
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    listItemSortFunctions(sort) {
        return {
            functions: [i => SpentEstimateField.getValue(i.item) || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {return AggregateSpentEstimateComponent.bind(null, this.getAggregateOptions());}
}